import * as tslib_1 from "tslib";
import FormatButton from './FormatButton';
import toggleColorMenuIsShown from '../actions/toggleColorMenuIsShown';
import store from '../store/store';
import { ColorPicker, textColors } from 'owa-color-picker';
import { getUserConfiguration } from 'owa-session-store';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { reactive } from 'satcheljs/lib/legacy/react';
var ColorPickerButton = /** @class */ (function (_super) {
    tslib_1.__extends(ColorPickerButton, _super);
    function ColorPickerButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onSelectColor = function (value) {
            _this.props.onSelectColor(value.code);
        };
        return _this;
    }
    ColorPickerButton.prototype.render = function () {
        var _this = this;
        var isShown = this.props.optionStore.isColorMenuShown;
        return (React.createElement("div", null,
            React.createElement(FormatButton, { type: "textcolor", isSelected: false, ref: function (ref) { return (_this.anchorButton = ReactDOM.findDOMNode(ref)); }, onClick: isShown ? this.onDismissMenu : this.onShowMenu }),
            isShown && (React.createElement(ColorPicker, { menuTargetElement: this.anchorButton, colors: textColors.get(), onDismissMenu: this.onDismissMenu, onSelectColor: this.onSelectColor, shouldFocusOnMount: true }))));
    };
    ColorPickerButton.prototype.onShowMenu = function () {
        toggleColorMenuIsShown(true);
    };
    ColorPickerButton.prototype.onDismissMenu = function () {
        toggleColorMenuIsShown(false);
    };
    ColorPickerButton = tslib_1.__decorate([
        reactive({
            optionStore: function () { return store; },
            userOptions: function () { return getUserConfiguration().UserOptions; },
        })
    ], ColorPickerButton);
    return ColorPickerButton;
}(React.Component));
export default ColorPickerButton;
//# sourceMappingURL=ColorPickerButton.js.map